import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../actions/baseAction';
import * as commonAction from '../actions/commonAction';
import * as reportAction from '../actions/reportAction';


class Test extends React.Component {

  constructor(props) {
    super(props);
  }

  handleChange(){
      notifiyDesk();
  }

  componentDidMount(){
    this.props.$$REPORT.getPersonalDailyWage('2018-03-01 00:00:00', '2018-04-30 00:00:00', 0)
  }

  render() {
    return (
      <div className='jssm-animation'>
      
      </div>
    );
  }
}

reactMixin(Test.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$COMMON: bindActionCreators(commonAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$REPORT: bindActionCreators(reportAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Test)